import { render, staticRenderFns } from "./water-fall.vue?vue&type=template&id=7d0349f7&scoped=true&"
import script from "./water-fall.vue?vue&type=script&lang=js&"
export * from "./water-fall.vue?vue&type=script&lang=js&"
import style0 from "./water-fall.vue?vue&type=style&index=0&id=7d0349f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0349f7",
  null
  
)

export default component.exports